/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Mark_Ready_TooltipInputs */

const fr_week_session_mark_ready_tooltip = /** @type {(inputs: Week_Session_Mark_Ready_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer cette semaine comme prête pour l'athlète`)
};

/**

* @param {Week_Session_Mark_Ready_TooltipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_mark_ready_tooltip = /** @type {((inputs?: Week_Session_Mark_Ready_TooltipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Mark_Ready_TooltipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_mark_ready_tooltip(inputs)
});